<template>
  <div id="Degree">
     <v-expansion-panels v-if="savedSchool.bachelors_degree_required"  focusable class="px-2 ">
        <v-expansion-panel class="mt-2">
          <v-expansion-panel-header class="light-blue--text text--darken-4" >
            <v-layout row align-center pb-0 >
              <v-icon v-if="checkDegreeCompleted" color="green" >mdi-check-circle</v-icon>
              <v-icon  v-else color="red" >mdi-check-circle</v-icon>
              <v-icon color="blue darken-3" class="ml-2">mdi-school</v-icon>
              <span class="ml-2 blue--text text--darken-3 font-weight-medium">Degree</span>
            </v-layout>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">

            <v-card  class=" innerCardCover " flat >
                <v-layout v-if="savedSchool.bachelors_degree_required && !checkDegreeCompleted" justify-center  class=" red pb-2  ">
                  <span class="white--text text-center mt-2">Bachelor's Degree Required</span>
                </v-layout>
                <v-layout v-else justify-center  class="green pb-2  ">
                  <span class="white--text text-center mt-2">Bachelor's Degree Completed</span>
                </v-layout>
                <v-layout v-if="savedSchool.bachelors_degree_required === false " justify-center  class=" grey pb-2  ">
                  <span class="white--text text-center mt-2">Degree Not Required</span>
                </v-layout>
            </v-card>

            <!-- Degree Notes -->
            <v-card  v-if="savedSchool.degreeNotes" outlined class=" mt-4 mb-4 ">
              <v-layout align-center justify-center class=" pb-1" > 
                <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                <span class="font-weight-light align-center"> Additional Notes </span>
              </v-layout>
              <v-divider></v-divider>
              <v-card-text class="text-center">
                <span>{{savedSchool.degreeNotes}}</span>
              </v-card-text>
            </v-card>

          </v-expansion-panel-content>
        </v-expansion-panel>
     </v-expansion-panels>
  </div>
</template>

<script>
  import userMixins from '@/mixins/usersmixin'
  import checkDegreeMixin from '@/mixins/requirementchecks/checkdegreemixin'
  export default {
    mixins: [userMixins,checkDegreeMixin ],
    props: ['savedSchool', ],
    data() {
      return {

      }
    },

  }
</script>

<style scoped>
.v-expansion-panel::before {
   box-shadow: 0 10px 20px -10px rgba(0,0,0,.19)  !important;
}
.innerCardCover {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
  margin-bottom: 12px;
}



</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/RequirementTracker/Degree.vue